import { createApp } from 'vue';
import router from './router';
import App from './App';
import store from "./store/index";
import i18n from './i18n'

createApp(App).use(i18n).use(router).use(store).mount('#root')
